import { action, observable, decorate } from 'mobx';
import firebase from 'firebase/app';
import 'firebase/auth';
import { parseJwt } from '@helpers/functions';

class AuthStore {
  //Later make idToken lifetime for validating, if lifetime expired request new idToken else if do nothing.
  idToken = '';
  getUserDetails() {
    if (this.idToken !== '') {
      return parseJwt(this.idToken);
    }

    return null;
  }

  setIdToken = async () => {
    const idToken = await firebase.auth().currentUser.getIdToken();
    this.idToken = idToken;

    return this.getUserDetails();
  };

  getIdToken = async () => {
    let newIdToken = '';
    await firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
      newIdToken = idToken;
    }).catch(function(error) {
      console.error(error);
    });
    this.idToken = newIdToken;
  }
  isAuthenticated = () => {
    return this.idToken ? false : true;
  };

  resetIdToken = async () => {
    await firebase.auth().signOut();
    this.idToken = '';
  };
}

decorate(AuthStore, {
  idToken: observable,
  resetIdToken: action,
  isAuthenticated: action,
  setIdToken: action,
  getUserDetails: action,
});

export default new AuthStore();
